import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "footer-content" }
const _hoisted_2 = { class: "footer-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_qrcode_vue = _resolveComponent("qrcode-vue")!
  const _component_a_layout_footer = _resolveComponent("a-layout-footer")!

  return (_openBlock(), _createBlock(_component_a_layout_footer, { class: "footer bg-gray-800 bg-opacity-70" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "footer-left" }, [
          _createElementVNode("p", null, "© 2024 DevHelper. All rights reserved.")
        ], -1)),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_qrcode_vue, {
            value: "https://github.com/haihaycode/dev-helper",
            size: 50,
            level: 'L',
            background: 'white',
            margin: 2
          })
        ])
      ])
    ]),
    _: 1
  }))
}